import React, { createContext, DependencyList, useContext, useEffect, useState } from 'react'

import { Helmet } from 'react-helmet'

import { usePageApi } from '@providers/PageApiProvider'
import { formatPageTitle } from '@utils/helpers'

export interface LayoutContextType {
  pageTitle: string | null
  setPageTitle: (title: string) => void
}

export const PageLayoutContext = createContext<LayoutContextType>({
  pageTitle: null,
  setPageTitle: () => null,
})

interface Props {
  initialTitle?: string
}
const LayoutProvider: React.FC<Props> = ({ children, initialTitle }) => {
  const { pageData } = usePageApi()
  const [pageTitle, setPageTitle] = useState(initialTitle)

  useEffect(() => {
    if (initialTitle) setPageTitle(initialTitle)
  }, [initialTitle])

  return (
    <PageLayoutContext.Provider
      value={{
        pageTitle: pageTitle ?? (pageData as any)?.page_title ?? null,
        setPageTitle,
      }}>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      {children}
    </PageLayoutContext.Provider>
  )
}
export default LayoutProvider

export const usePageLayout = () => useContext(PageLayoutContext)

export const usePageTitle = (title: string, deps?: DependencyList) => {
  const { setPageTitle } = usePageLayout()
  useEffect(() => {
    setPageTitle(formatPageTitle(title))
  }, deps ?? [])
}
